import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStudioList = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `help-host-report/studios` });

  return data;
};

export default getStudioList;
